import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import BusyFlatButton from 'shared/components/BusyFlatButton';
import CloseModalButton from 'shared/components/CloseModalButton';
import TextField from 'material-ui/TextField';
import * as Colors from 'material-ui/styles/colors';
import { closeDialog } from '../helpers';

const style = {
  title: {
    color: Colors.gray700,
  },
  warnTitle: {
    color: '#fff',
    background: Colors.red900,
    padding: '14px 24px',
  },
  dialogBody: {
    paddingTop: '30px',
  },
  btn: {
    marginLeft: '8px',
  },
  warnBtnText: {
    color: Colors.red900,
  },
  closeIcon: {
    position: 'absolute',
    right: 8,
    top: 8,
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-between',
  },
};

export default class EditInfoImageDialog extends Component {
  static contextTypes = {
    imageUtils: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      fileName: '',
      error: '',
      busy: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.open && nextProps.open) {
      this.setState({error: '', fileName: nextProps.file.fileName}, () => {
        if (this.refs.input) {
          this.refs.input.input.setSelectionRange(0, nextProps.file.fileName.length);
          this.refs.input.focus();
        }
      });
    }
  }

  submit = () => {
    this.setState({ busy: true });
    const { fileName, path } = this.props.file;
    const newFileName = this.state.fileName;
    this.context.imageUtils.doRenameFile({
      path,
      fileName,
      newFileName
    }, (response) => {
      if (_.get(response, 'responseJSON.error.message', false)) {
        this.setState({ error: response.responseJSON.error.message, busy: false });
      } else {
        this.setState({ busy: false });
        this.closeDialog();
      }
    });
  };

  closeDialog = () => {
    if (this.props.integrated) {
      this.props.close();
    } else {
      closeDialog();
    }
  };

  handleKeyUp = (e) => {
    if (e.key === 'Enter') {
      this.submit();
    }
  };

  fileNameWithoutExtention(fileNameExt) {
    return _.join(_.dropRight(_.split(fileNameExt, '.')));
  }

  fileExtention(fileNameExt) {
    return _.last(_.split(fileNameExt, '.'));
  }

  render() {
    const { open, file: { fileName } } = this.props;
    const actions = [
      <FlatButton
        label="Cancel"
        disabled={this.state.busy}
        onClick={this.closeDialog}
      />,
      <BusyFlatButton
        labels={['Save', 'Saving']}
        busy={this.state.busy}
        onClick={this.submit}
        style={style.btn}
        disabled={this.state.fileName === fileName}
        primary
      />,
    ];
    return (
      <Dialog
        title={
          <div>
            <CloseModalButton
              onClick={this.closeDialog}
              style={style.closeIcon}
            />
            Rename image
          </div>
        }
        actions={actions}
        actionsContainerStyle={style.actions}
        modal={false}
        open={open}
        onRequestClose={this.closeDialog}
        titleStyle={style.title}
        style={{zIndex: 1501}}
      >
        <TextField
          hintText="Enter a meaningful name like: Pink vacuum cleaners"
          floatingLabelText="Image Name"
          ref="input"
          value={this.fileNameWithoutExtention(this.state.fileName)}
          errorText={this.state.error}
          onChange={(event, value) => this.setState({ fileName: `${value}.${this.fileExtention(this.state.fileName)}` })}
          onKeyUp={this.handleKeyUp}
          floatingLabelFixed
          autoFocus
          fullWidth
        />
      </Dialog>
    );
  }
}

EditInfoImageDialog.propTypes = {
  open: PropTypes.bool,
};